import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ResetWarning from './resetWarning/ResetWarning';
import {
  updateConfigWithSelections,
  updateConfigWithStyleIdAndSerializedState,
} from '../../store/actions';
import { CONFIG, TRIMS } from '../../common/steps';
import withSaveBuild from '../../common/saveBuild/SaveBuild';
import { withNotifications } from '../../common/notifications/NotificationsContext';
import { withTranslate } from 'core/translate';
import { find } from 'lodash';
import { useModelInfo } from '../../common/ModelInfoContext';

const ConfigPage = (props) => {
  const [optionAfterWarning, setOptionAfterWarning] = useState(null);
  const [updatingOption, setUpdatingOption] = useState(null);

  const {
    children,
    config,
    isUpdating,
    saveBuild,
    notifications,
    translate,
    step,
    matrix,
  } = props;
  const { show } = notifications;

  const { enablePopConsTrimFilters } = useModelInfo();

  const hasKeyFeatures = !!find(
    matrix.bodyTypes,
    (bodyType) => bodyType?.keyFeatures.length > 0
  );

  const displayTrimFilters = enablePopConsTrimFilters && hasKeyFeatures;

  useEffect(() => {
    if (updatingOption) {
      const { step, wasOptionToggled, wasTrimOptionToggled, onChange } = props;
      const { styleId, ss } = updatingOption;

      if (wasOptionToggled || (step === CONFIG && wasTrimOptionToggled)) {
        setOptionAfterWarning(updatingOption);
        return;
      }

      onChange(styleId, ss, { toggledTrim: step === TRIMS }, step);
    }
  }, [updatingOption]);

  const onTrimChange = (option, isDriveTypeChanged) => {
    if (isDriveTypeChanged) {
      const { onChange } = props;
      const { styleId, ss } = option;
      onChange(styleId, ss, { toggledTrim: false });
    } else {
      setUpdatingOption(option);
    }
  };

  const onTrimWarningSelect = () => {
    const { step, onChange } = props;
    const option = optionAfterWarning;
    const { styleId, ss } = option;

    setOptionAfterWarning(null);

    onChange(styleId, ss, { toggledTrim: step === TRIMS });
  };

  const onSaveStartOver = (event) => {
    saveBuild();

    const savedMassage = `${translate('saved')}!`;
    show(savedMassage, event, 'saved');

    onTrimWarningSelect();
  };

  const onWarningCancel = () => {
    setOptionAfterWarning(null);
    setUpdatingOption(null);
  };

  return (
    <>
      {children({
        onTrimChange,
        isUpdating,
        updatingOption,
        displayTrimFilters,
      })}

      {optionAfterWarning && (
        <ResetWarning
          step={step}
          option={optionAfterWarning}
          packages={config.packages}
          onReset={onTrimWarningSelect}
          onSaveStartOver={onSaveStartOver}
          onClose={onWarningCancel}
        />
      )}
    </>
  );
};

ConfigPage.propTypes = {
  step: PropTypes.string.isRequired,
  children: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const {
    config,
    wasOptionToggled,
    wasTrimOptionToggled,
    isUpdating,
    matrix,
  } = state;
  return {
    config,
    wasOptionToggled,
    wasTrimOptionToggled,
    isUpdating,
    matrix,
  };
};

const mapDispatchToProps = (dispatch) => {
  const onChange = (styleId, ss, options, step) =>
    dispatch(
      updateConfigWithStyleIdAndSerializedState(styleId, ss, options, step)
    );
  const onConflictSelect = (selections) =>
    dispatch(updateConfigWithSelections(selections));

  return {
    onChange,
    onConflictSelect,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslate(withNotifications(withSaveBuild(ConfigPage))));
